/**
 * Extrai a mensagem de erro de uma resposta de API
 * Lida com erros de validação do FluentValidation (array) e erros de domínio (objeto com propriedade error)
 */
export const extractErrorMessage = (error: any, defaultMessage: string): string => {
  const responseData = error.response?.data;

  if (Array.isArray(responseData)) {
    // FluentValidation errors - retorna a primeira mensagem de erro
    const firstError = responseData[0];
    return firstError?.errorMessage || defaultMessage;
  } else if (responseData?.error) {
    // Domain exception error
    return responseData.error;
  } else {
    return defaultMessage;
  }
};
